export class DeviceValidation{
  key:string;
  responseKey:string;
}
